export const partnerLogos = [
  {
    id: "associated-british-foods",
    src: "/images/logo/partners/associated-british-foods-logo.svg",
    alt: "Associated British Foods",
    width: 150,
    height: 50,
  },
  {
    id: "stella-mccartney",
    src: "/images/logo/partners/stella-mccartney.svg",
    alt: "Stella McCartney",
    width: 210,
    height: 60,
    wide: true,
  },
  {
    id: "saint-laurent",
    src: "/images/logo/partners/saint-laurent.svg",
    alt: "Saint Laurent",
    width: 176,
    height: 60,
  },
  {
    id: "bottega-veneta",
    src: "/images/logo/partners/bottega-veneta.svg",
    alt: "Bottega Veneta",
    width: 160,
    height: 44,
  },
  {
    id: "british-sugar",
    src: "/images/logo/partners/british-sugar.svg",
    alt: "British Sugar",
    width: 168,
    height: 60,
  },
  {
    id: "brompton",
    src: "/images/logo/partners/brompton.svg",
    alt: "Brompton",
    width: 162,
    height: 60,
  },
  {
    id: "diploma-plc",
    src: "/images/logo/partners/diploma-plc.svg",
    alt: "Diploma PLC",
    width: 154,
    height: 50,
  },
  {
    id: "ds-smith",
    src: "/images/logo/partners/ds-smith.svg",
    alt: "DS Smith",
    width: 102,
    height: 56,
  },
  {
    id: "first-circle",
    src: "/images/logo/partners/first-circle.svg",
    alt: "First Circle",
    width: 158,
    height: 60,
  },
  {
    id: "jjchurchill",
    src: "/images/logo/partners/jjchurchill.svg",
    alt: "JJ Churchill",
    width: 180,
    height: 60,
  },
  {
    id: "jordans",
    src: "/images/logo/partners/jordans.svg",
    alt: "Jordans",
    width: 142,
    height: 48,
  },
  {
    id: "jpl-flavours",
    src: "/images/logo/partners/jpl-flavours.svg",
    alt: "JPL Flavours",
    width: 110,
    height: 56,
  },
  {
    id: "kering",
    src: "/images/logo/partners/kering.svg",
    alt: "Kering",
    width: 130,
    height: 60,
    wide: true,
  },
  {
    id: "new-balance",
    src: "/images/logo/partners/New-Balance.svg",
    alt: "New Balance",
    width: 150,
    height: 54,
  },
  {
    id: "paramount",
    src: "/images/logo/partners/paramount.svg",
    alt: "Paramount",
    width: 100,
    height: 65,
  },
  {
    id: "prada",
    src: "/images/logo/partners/prada.svg",
    alt: "Prada",
    width: 146,
    height: 60,
  },
  {
    id: "suzuki",
    src: "/images/logo/partners/suzuki.svg",
    alt: "Suzuki",
    width: 158,
    height: 60,
  },
  {
    id: "wd-40",
    src: "/images/logo/partners/wd-40.svg",
    alt: "WD-40",
    width: 138,
    height: 60,
  },
  {
    id: "whitworth-bros",
    src: "/images/logo/partners/whitworth-bros.svg",
    alt: "Whitworth Bros",
    width: 188,
    height: 60,
    wide: true,
  },
  {
    id: "willowbrook-construction",
    src: "/images/logo/partners/willowbrook-construction.svg",
    alt: "Willowbrook Construction",
    width: 190,
    height: 60,
  },
];

export const partnerLogoMap = Object.fromEntries(
  partnerLogos.map((logo) => [logo.id, logo]),
);
